module.exports = __webpack_public_path__ + "img/annafali.934d0232.png";